import { render, staticRenderFns } from "./PxFornecedorDetalhes.vue?vue&type=template&id=74008e40"
import script from "./PxFornecedorDetalhes.vue?vue&type=script&lang=js"
export * from "./PxFornecedorDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports